const LAST_ACTIVE_KEY = 'workloop.lastActiveAt';
const SHOWN_DATE_KEY = 'workloop.digestShownDateIst';
export const DIGEST_AWAY_MS = 5 * 60 * 60 * 1000;
export const DIGEST_IST_ZONE = 'Asia/Kolkata';
export const DIGEST_TEN_AM_HOUR = 10;

const daySuffix = (day) => {
  if (day === 11 || day === 12 || day === 13) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

export const NIGHT_OWL_GREETINGS = [
  'Hello, night owl! 🌙',
  'Hey, midnight explorer! ✨',
  'Still awake? Welcome aboard! 🌃',
  'Hey there, late-night legend! 😎',
  'Hello, moonlight buddy! 🌙',
  "What's up, night owl? 🦉",
  'Hey, midnight warrior! 💪',
  'Welcome to the late-night club! 🌌',
  'Burning the midnight oil? 🔥',
  'Hey, champion of the night! 🏆',
];

export const isNightOwlHour = (date = new Date()) => {
  const hour = date.getHours();
  return hour >= 0 && hour < 4;
};

export const pickNightOwlGreeting = () => {
  const index = Math.floor(Math.random() * NIGHT_OWL_GREETINGS.length);
  return NIGHT_OWL_GREETINGS[index];
};

export const greetingForLocalHour = (date = new Date()) => {
  if (isNightOwlHour(date)) return pickNightOwlGreeting();
  const hour = date.getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 17) return 'Good Afternoon';
  return 'Good Evening';
};

export const formatTodayDigestLabel = (date = new Date()) => {
  const day = date.getDate();
  const monthYear = date.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
  const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
  return `${day}${daySuffix(day)} ${monthYear} (${weekday})`;
};

export const readLastActiveAt = () => {
  const raw = Number(window.localStorage.getItem(LAST_ACTIVE_KEY) || 0);
  return Number.isFinite(raw) && raw > 0 ? raw : 0;
};

export const touchLastActiveAt = () => {
  window.localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));
};

export const isAwayForDigest = (gapMs = DIGEST_AWAY_MS) => {
  const last = readLastActiveAt();
  if (!last) return true;
  return Date.now() - last >= gapMs;
};

const istParts = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: DIGEST_IST_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value;
  return {
    dateStr: `${get('year')}-${get('month')}-${get('day')}`,
    hour: Number(get('hour')),
    minute: Number(get('minute')),
    second: Number(get('second')),
  };
};

export const todayIstDateStr = () => istParts().dateStr;

export const markDigestShownTodayIst = () => {
  window.localStorage.setItem(SHOWN_DATE_KEY, todayIstDateStr());
};

export const hasDigestComeTodayIst = () => (
  window.localStorage.getItem(SHOWN_DATE_KEY) === todayIstDateStr()
);

/** 10:00 IST briefing: once per IST day, even without a 5-hour gap. */
export const isTenAmIstDue = () => {
  if (hasDigestComeTodayIst()) return false;
  return istParts().hour >= DIGEST_TEN_AM_HOUR;
};

export const msUntilTenAmIst = (now = new Date()) => {
  if (hasDigestComeTodayIst()) return null;
  if (isTenAmIstDue()) return 0;
  const istOffsetMs = (5 * 60 + 30) * 60 * 1000;
  const istWall = new Date(now.getTime() + istOffsetMs);
  const targetWall = Date.UTC(
    istWall.getUTCFullYear(),
    istWall.getUTCMonth(),
    istWall.getUTCDate(),
    DIGEST_TEN_AM_HOUR,
    0,
    0,
    0,
  );
  const nowWall = Date.UTC(
    istWall.getUTCFullYear(),
    istWall.getUTCMonth(),
    istWall.getUTCDate(),
    istWall.getUTCHours(),
    istWall.getUTCMinutes(),
    istWall.getUTCSeconds(),
    istWall.getUTCMilliseconds(),
  );
  return Math.max(0, targetWall - nowWall);
};

export const shouldAutoOpenDigest = () => isAwayForDigest() || isTenAmIstDue();

const HIDE_NEWS_KEY = 'workloop.digestHideNews';

export const readDigestHideNews = () =>
  window.localStorage.getItem(HIDE_NEWS_KEY) === '1';

export const writeDigestHideNews = (hide) => {
  window.localStorage.setItem(HIDE_NEWS_KEY, hide ? '1' : '0');
};
